import { createApp } from 'vue';
import OggToMp3Converter from '@/Components/OggToMp3Converter.vue';
import '@styles/app.css';

createApp(OggToMp3Converter).mount('#ogg-to-mp3-converter');
